// type 1 is Number, 2 is Date, 0 is String
// type 3 is hour
import moment from 'moment';
let sortFunction = function (field, reverse = false, type = 0) {
  reverse = !reverse ? 1 : -1;
  return function (el1, el2) {
    let a = el1[field];
    let b = el2[field];
    if (type === 2) {
      a = new Date(a);
      b = new Date(b);
    }
    if (type === 0) {
      a = a ? a.toString().toLowerCase() : '';
      b = b ? b.toString().toLowerCase() : '';
    }

    function getMomentObject (str) {
      let listStr = str.toString().split(/[\s:]/);
      let minute = Number(listStr[1]);
      let hour = Number(listStr[0]);
      let hourType = listStr[2];
      hour = hourType === 'AM' ? hour : hour + 12;
      return moment({h: hour, m: minute});
    }

    if (type === 3) {
      a = getMomentObject(a);
      b = getMomentObject(b);
    }
    return reverse * ((a > b) - (b > a));
  };
};

// Return: 1 is Number, 2 is Date, 0 is String, 3 is Time
const getMappingObjectType = function (fieldName) {
  const mappingObj = {
    fullName: 0,
    firstName: 0,
    lastName: 0,
    cardCode: 0,
    email: 0,
    prefDate: 2,
    timeSlot: 3,
    startTime: 3,
    endTime: 3,
    phone: 0,
    agency: 1,
    role: 0,
    name: 0,
    screeningTime: 3,
    mileageRate: 1,
    internalName: 2
  };
  return mappingObj[fieldName] ? mappingObj[fieldName] : 0;
};

export default {
  sortFunction: sortFunction,
  getMappingObjectType: getMappingObjectType
};



// WEBPACK FOOTER //
// ./src/utils/array-helper.js